import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { switchMap, tap } from 'rxjs';
import { AnchorModel } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-avviso',
  templateUrl: './page-avviso.component.html',
  styleUrls: ['./page-avviso.component.scss']
})
export class PageAvvisoComponent implements OnInit {

  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() isSecondLevelUp: boolean = false;
  public domainWebsite = environment.urlApi;
  public relatedAvvisi: any[] = [];
  public idAnchor: string = '';
  public block: any;
  public imgPath = "";
  public isSpinner: boolean = false;
  public titlePage: string = '';
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public dataFieldTaxonomies: any[] = [];
  //MODALE SHARE
  public onHoverShare: boolean = false;

  constructor(
    public helpersService: HelpersService,
    public nodeService: NodeService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.onInitiComponent();
  }
  
  private onInitiComponent(): void {
    this.isSpinner = true;
    if (this.node.field_scadenza_avviso && this.node.field_scadenza_avviso.length) {
      const datetimeTEMP: string = this.node.field_scadenza_avviso[0].value;
      // const datetimeTEMP: string = this.block.field_scadenza_avviso.match(/datetime="(.*?)"/)[1];
      const dateTime = new Date(datetimeTEMP);
      const dateNow = Date.now();
      if (dateTime.getTime() < dateNow) {
        this.nodeService.getRowTypeView(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, this.node.field_tipo_view[0].value, this.node.preview, this.node.nid[0].value).subscribe(res => {
          this.router.navigate([res[0].field_redirect_url]);
        })
      } else {
        this.getRow();
        this.isSpinner = false;
      }
    } else {
      this.getRow();
      this.isSpinner = false;
    }
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });
  }
  
  private getRow(): void {
    this.nodeService.getRowTypeView(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, this.node.field_tipo_view[0].value, this.node.preview, this.node.nid[0].value).pipe(
      tap(resView => {
        this.block = resView[0];
        this.titlePage = this.helpersService.retriveLinkTagA(this.block.field_titolo, 'a').title;
        this.setDataFields(this.block);
      }),
      switchMap(nodeAvvisi => this.nodeService.getRelatedViewAvvisiCorso(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, nodeAvvisi[0].field_tassonomia_corsi_di_laurea, this.node.nid[0].value, this.node.preview))
      ).subscribe(relatedAvvisi => {
      let temp: any[] = [];
      relatedAvvisi.forEach((element: any) => {
        temp.push(this.nodeService.transformResultsExport(element));
      });
      if (temp.length > 6) {
        for (let idx = 0; idx < 6; idx++) {
          this.relatedAvvisi.push(temp[idx]);
        }
      } else {
        this.relatedAvvisi = temp;
      }
    });
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    let boundingCollapse;
    if (!this.isSpinner && this.node) {
      boundingCollapse = document.querySelector('.container-field-taxonomies')?.getBoundingClientRect();
    }
    if ((boundingCollapse && boundingCollapse.y < -40 && boundingCollapse.width > 767) || (boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width <= 767)) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }
  }

  addNewAnchorItem(value: AnchorModel) {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  }

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private setDataFields(block: any): void {
    if (block.field_tassonomia_dipartimento.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_AVVISO.DEPARTMENT',
          value: block.field_tassonomia_dipartimento,
          isArray: true
        }
      ]
    }
    if (block.field_tassonomia_area_universita.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_AVVISO.UNIVERSITY_AREAS',
          value: block.field_tassonomia_area_universita,
          isArray: true
        }
      ]
    }
    if (block.field_tassonomia_corsi_di_laurea.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_AVVISO.DEGREE_COURSES',
          value: block.field_tassonomia_corsi_di_laurea,
          isArray: true
        }
      ]
    }
    if (block.field_tags.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_AVVISO.TAG',
          value: block.field_tags,
          isArray: true
        }
      ]
    }
    // if (block.field_autore) {
    //   this.dataFieldTaxonomies = [
    //     ...this.dataFieldTaxonomies,
    //     {
    //       titolo: 'CONTENT_TYPES.PAGE_AVVISO.AUTHOR',
    //       value: block.field_autore,
    //       isArray: false
    //     }
    //   ]
    // }
  }

}
